import PropTypes from 'prop-types';
import React from 'react';
import moment from 'moment';
import styles from './ActiveStaffList.css';
import OutletCell from './OutletCell';
import StaffStatus from './StaffStatus';

class ActiveStaffList extends React.Component {
  render() {
    const { activeEmployees, openRightColumn } = this.props;

    return (
      <div className={styles.wrapper}>
        <table className={styles['table-header']}>
          <thead>
            <tr>
              <th>Employee Name</th>
              <th>Role</th>
              <th>Assigned Outlet</th>
              <th>Expiration Date</th>
              <th>Slot Status</th>
              {!openRightColumn && <th>Employee Status</th>}
            </tr>
          </thead>
        </table>
        <div
          className={`${
            styles['table-content-wrapper']
          } staff-table-content-wrapper`}
        >
          <table className={`${styles['table-content']}`}>
            <tbody>{activeEmployees.map(this._renderActiveEmployeeRow)}</tbody>
          </table>
        </div>
      </div>
    );
  }

  _renderActiveEmployeeRow = activeEmployee => {
    const { outlets, openRightColumn, slotDetail, mokapayMode } = this.props;
    const emptyField = '-';
    let className = '';
    const isSlotClicked = slotDetail && slotDetail.id === activeEmployee.id;

    if (isSlotClicked) {
      className = styles.selected;
    }

    return (
      <tr
        key={activeEmployee.id}
        className={`${className}`}
        onClick={() => {
          activeEmployee.employee
            ? this.props.onClickRow({ employee: activeEmployee })
            : this.props.onClickInviteStaff({ slot: activeEmployee });
        }}
      >
        <td>
          {activeEmployee.employee
            ? `${activeEmployee.employee.first_name} ${activeEmployee.employee.last_name}`
            : emptyField}
        </td>
        <td className={styles.role}>
          {(activeEmployee.employee &&
            activeEmployee.employee.role &&
            activeEmployee.employee.role.name) ||
            emptyField}
        </td>
        <td>
          <OutletCell
            outlets={activeEmployee.employee && activeEmployee.employee.outlets}
            allOutlet={
              activeEmployee.employee &&
              activeEmployee.employee.outlets &&
              activeEmployee.employee.outlets.length === outlets.length
            }
          />
        </td>
        <td>
          {mokapayMode
            ? 'N/A'
            : moment(activeEmployee.expireDate).format('DD MMM YYYY')}
        </td>
        <td>{activeEmployee.status}</td>
        {!openRightColumn && (
          <td>
            <StaffStatus
              slot={activeEmployee}
              email={activeEmployee.employee && activeEmployee.employee.email}
              onClickInviteStaff={({ slot }) =>
                this.props.onClickInviteStaff({ slot })
              }
              onClickResendInvitation={({ email }) =>
                this.props.onClickResendInvitation({ email })
              }
            />
          </td>
        )}
      </tr>
    );
  };
}

ActiveStaffList.propTypes = {
  activeEmployees: PropTypes.array,
  onClickRow: PropTypes.func,
  onClickInviteStaff: PropTypes.func,
  onClickResendInvitation: PropTypes.func,
  outlets: PropTypes.array,
  openRightColumn: PropTypes.bool,
  mokapayMode: PropTypes.bool,
};

ActiveStaffList.defaultProps = {
  // FIXME It is still better to have API returns falsy value for expiration date
  mokapayMode: false,
};

export default ActiveStaffList;
